import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SharedAccessControlService {
    handleTemplateNameChanges(templateNameControl: AbstractControl) {
        return templateNameControl?.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            map((value) => {
                const hasLeadingTrailingSpaces = value !== value.trim();

                if (hasLeadingTrailingSpaces) {
                    if (!templateNameControl.hasError('leadingTrailingSpaces')) {
                        templateNameControl.setErrors({ leadingTrailingSpaces: true });
                    }
                } else {
                    if (templateNameControl.hasError('leadingTrailingSpaces')) {
                        const errors = { ...templateNameControl.errors };
                        delete errors['leadingTrailingSpaces'];
                        templateNameControl.setErrors(Object.keys(errors).length === 0 ? null : errors);
                    }
                }

                return templateNameControl.hasError('leadingTrailingSpaces');
            })
        );
    }
}
